import n from "./index.es144.js";
import m from "./index.es269.js";
import u from "./index.es270.js";
import { getFetch as g } from "./index.es271.js";
import f from "./index.es155.js";
const s = {
  http: m,
  xhr: u,
  fetch: {
    get: g
  }
};
n.forEach(s, (e, a) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: a });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: a });
  }
});
const l = (e) => `- ${e}`, b = (e) => n.isFunction(e) || e === null || e === !1, P = {
  getAdapter: (e, a) => {
    e = n.isArray(e) ? e : [e];
    const { length: p } = e;
    let i, t;
    const c = {};
    for (let r = 0; r < p; r++) {
      i = e[r];
      let o;
      if (t = i, !b(i) && (t = s[(o = String(i)).toLowerCase()], t === void 0))
        throw new f(`Unknown adapter '${o}'`);
      if (t && (n.isFunction(t) || (t = t.get(a))))
        break;
      c[o || "#" + r] = t;
    }
    if (!t) {
      const r = Object.entries(c).map(
        ([d, h]) => `adapter ${d} ` + (h === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = p ? r.length > 1 ? `since :
` + r.map(l).join(`
`) : " " + l(r[0]) : "as no adapter specified";
      throw new f(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return t;
  },
  adapters: s
};
export {
  P as default
};
//# sourceMappingURL=index.es159.js.map
